var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import Slider from 'rc-slider';
import { Drawer, Icon, Wrapper, Loading } from '@mademine/components';
import { I18n, canvasToBlob, findScaleToCover, findScaleToContain, animate, Ease, Gtag, urlToBlob } from '@mademine/utils';
import Button from '../Button';
import Header from '../Header';
import { ReactComponent as RotateLeft } from '../../assets/icon-rotate-left.svg';
import { ReactComponent as RotateRight } from '../../assets/icon-rotate-right.svg';
import { ReactComponent as CircleWarnLine } from '../../assets/icon-circle-warn-line.svg';
import './style.module.less';
var Croppie = function (_a) {
    var source = _a.source, maxZoom = _a.maxZoom, maxCropperRatio = _a.maxCropperRatio, renderHeaderCloseContent = _a.renderHeaderCloseContent, onClose = _a.onClose, onConfirm = _a.onConfirm;
    var _image = useRef(null);
    var _cropper = useRef();
    var _preCropBox = useRef();
    var _preCanvasData = useRef();
    var _reCalcZoom = useRef(false);
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(true), disabled = _c[0], setDisabled = _c[1];
    var _d = useState([]), zoomLimit = _d[0], setZoomLimit = _d[1];
    var _e = useState(1), zoom = _e[0], setZoom = _e[1];
    var _f = useState(false), warnVisible = _f[0], setWarnVisible = _f[1];
    var _getRotateImageData = function (_a) {
        var naturalWidth = _a.naturalWidth, width = _a.width, naturalHeight = _a.naturalHeight, height = _a.height, _b = _a.rotate, rotate = _b === void 0 ? 0 : _b;
        return rotate % 180 === 0
            ? {
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight,
                width: width,
                height: height
            }
            : {
                width: height,
                height: width,
                naturalWidth: naturalHeight,
                naturalHeight: naturalWidth
            };
    };
    useEffect(function () {
        if (_image.current) {
            var paramCropper = source.paramCropper;
            var initialAspectRatio = paramCropper
                ? paramCropper[0] / paramCropper[1]
                : undefined;
            var aspectRatio = maxCropperRatio ? undefined : initialAspectRatio;
            _cropper.current = new Cropper(_image.current, {
                viewMode: 0,
                dragMode: 'move',
                autoCropArea: 1,
                background: false,
                cropBoxMovable: false,
                initialAspectRatio: initialAspectRatio,
                aspectRatio: aspectRatio,
                data: source.cropperData,
                zoom: function (event) {
                    var cropper = event.target.cropper;
                    var _zoomLimit = _calcZoomLimit();
                    if (event.detail.ratio > _zoomLimit[1]) {
                        event.preventDefault();
                        cropper.zoomTo(_zoomLimit[1]);
                    }
                    else if (event.detail.ratio < _zoomLimit[0]) {
                        event.preventDefault();
                        cropper.zoomTo(_zoomLimit[0]);
                    }
                    else {
                        _reCalcZoom.current = true;
                        setZoom(event.detail.ratio);
                    }
                },
                crop: function (event) {
                    if (_reCalcZoom.current) {
                        var cropper = event.target.cropper;
                        _reCalcZoom.current = false;
                        _ajustCanvasInsetCropbox(cropper);
                    }
                },
                cropstart: function (event) {
                    var cropper = event.target.cropper;
                    _preCropBox.current = cropper.getCropBoxData();
                    _preCanvasData.current = cropper.getCanvasData();
                },
                cropend: function (event) {
                    var _a, _b;
                    var cropper = event.target.cropper;
                    if (['move'].indexOf(event.detail.action) > -1) {
                        _ajustCanvasInsetCropbox(cropper);
                    }
                    else if (['ne', 'nw', 'se', 'sw'].indexOf(event.detail.action) > -1) {
                        var cropperData = cropper.getData();
                        var containerData = cropper.getContainerData();
                        var cropBoxData = cropper.getCropBoxData();
                        var canvasData = cropper.getCanvasData();
                        var tolerance = Math.max(containerData.width, containerData.height) * 0.002;
                        if (cropBoxData.left < canvasData.left - tolerance ||
                            cropBoxData.top < canvasData.top - tolerance ||
                            cropBoxData.left + cropBoxData.width >
                                canvasData.left + canvasData.width + tolerance ||
                            cropBoxData.top + cropBoxData.height >
                                canvasData.top + canvasData.height + tolerance) {
                            (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.setCropBoxData({
                                left: Math.max(cropBoxData.left, canvasData.left),
                                top: Math.max(cropBoxData.top, canvasData.top),
                                width: Math.min(cropBoxData.width, canvasData.left + canvasData.width - cropBoxData.left, canvasData.width),
                                height: Math.min(cropBoxData.height, canvasData.top + canvasData.height - cropBoxData.top, canvasData.height)
                            });
                            _ajustCropboxToFit();
                            return;
                        }
                        var _c = _getRotateImageData(cropper.getImageData()), width = _c.naturalWidth, height = _c.naturalHeight;
                        var scale = findScaleToContain(cropperData, { width: width, height: height });
                        if (scale > maxZoom) {
                            setWarnVisible(true);
                            (_b = _cropper.current) === null || _b === void 0 ? void 0 : _b.setCropBoxData(_preCropBox.current || {});
                        }
                        else {
                            _ajustCropboxToFit();
                        }
                        setZoomLimit(_calcZoomLimit());
                    }
                },
                ready: function () {
                    _ajustCropboxToFit(false);
                    var _zoomLimit = _calcZoomLimit();
                    setZoomLimit(_zoomLimit);
                    setLoading(false);
                    setDisabled(false);
                }
            });
        }
        return function () {
            if (_cropper.current)
                _cropper.current.destroy();
        };
    }, []);
    var _ajustCanvasInsetCropbox = function (cropper) {
        var cropBoxData = cropper.getCropBoxData();
        var canvasData = cropper.getCanvasData();
        var left = canvasData.left;
        var top = canvasData.top;
        if (cropBoxData.left < canvasData.left)
            left = cropBoxData.left;
        if (cropBoxData.top < canvasData.top)
            top = cropBoxData.top;
        if (cropBoxData.left + cropBoxData.width >
            canvasData.left + canvasData.width)
            left = cropBoxData.left + cropBoxData.width - canvasData.width;
        if (cropBoxData.top + cropBoxData.height >
            canvasData.top + canvasData.height)
            top = cropBoxData.top + cropBoxData.height - canvasData.height;
        cropper.setCanvasData(__assign(__assign({}, canvasData), { left: left, top: top }));
        return canvasData.left !== left || canvasData.top !== top;
    };
    var _ajustCropboxToFit = function (ease) {
        var _a;
        if (ease === void 0) { ease = true; }
        if (_cropper.current) {
            var container = _cropper.current.getContainerData();
            var cropBox = _cropper.current.getCropBoxData();
            var cropper = _cropper.current.getData();
            var canvas_1 = _cropper.current.getCanvasData();
            if (maxCropperRatio) {
                if (maxCropperRatio >= 1) {
                    if (cropBox.width > cropBox.height &&
                        cropBox.width / cropBox.height > maxCropperRatio) {
                        cropBox.height = cropBox.width / maxCropperRatio;
                    }
                    else if (cropBox.height > cropBox.width &&
                        cropBox.height / cropBox.width > maxCropperRatio) {
                        cropBox.width = cropBox.height / maxCropperRatio;
                    }
                }
                else if (maxCropperRatio > 0) {
                    if (cropBox.width < cropBox.height &&
                        cropBox.width / cropBox.height < maxCropperRatio) {
                        cropBox.height = cropBox.width / maxCropperRatio;
                    }
                    else if (cropBox.height < cropBox.width &&
                        cropBox.height / cropBox.width < maxCropperRatio) {
                        cropBox.width = cropBox.height / maxCropperRatio;
                    }
                }
            }
            var scale = findScaleToContain(cropBox, container) * 0.8;
            var newCropbox = {
                left: (container.width - cropBox.width * scale) / 2,
                top: (container.height - cropBox.height * scale) / 2,
                width: cropBox.width * scale,
                height: cropBox.height * scale
            };
            _cropper.current.setCropBoxData(newCropbox);
            var newZoom_1 = newCropbox.width / cropper.width;
            var _zoomLimit = _calcZoomLimit();
            if (newZoom_1 > _zoomLimit[1])
                newZoom_1 = _zoomLimit[1];
            else if (newZoom_1 < _zoomLimit[0])
                newZoom_1 = _zoomLimit[0];
            if (ease)
                animate({
                    from: {
                        left: cropBox.left - cropper.x * (cropBox.width / cropper.width),
                        top: cropBox.top - cropper.y * (cropBox.height / cropper.height),
                        scale: cropBox.width / cropper.width
                    },
                    to: {
                        left: newCropbox.left - cropper.x * newZoom_1,
                        top: newCropbox.top - cropper.y * newZoom_1,
                        scale: newZoom_1
                    },
                    duration: 800,
                    ease: Ease.easeOutExpo,
                    onUpdate: function (latest) {
                        var _a;
                        (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.setCanvasData(__assign(__assign({}, canvas_1), { left: latest.left, top: latest.top, width: canvas_1.naturalWidth * latest.scale, height: canvas_1.naturalHeight * latest.scale }));
                        setZoom(latest.scale);
                    },
                    onComplete: function () {
                        var _a;
                        (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.zoomTo(newZoom_1);
                    }
                });
            else {
                _cropper.current.setCanvasData(__assign(__assign({}, canvas_1), { left: newCropbox.left - cropper.x * newZoom_1, top: newCropbox.top - cropper.y * newZoom_1, width: canvas_1.naturalWidth * newZoom_1, height: canvas_1.naturalHeight * newZoom_1 }));
                setZoom(newZoom_1);
                (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.zoomTo(newZoom_1);
            }
        }
    };
    var _calcZoomLimit = function () {
        if (_cropper.current) {
            var cropbox = _cropper.current.getCropBoxData();
            var _a = _getRotateImageData(_cropper.current.getImageData()), width = _a.naturalWidth, height = _a.naturalHeight;
            return [
                findScaleToCover({ width: width, height: height }, cropbox),
                findScaleToCover({ width: width / maxZoom, height: height / maxZoom }, cropbox)
            ];
        }
        return [];
    };
    var _adjustCropboxToContainCanvas = function (cropper) {
        var containerData = cropper.getContainerData();
        var cropBoxData = cropper.getCropBoxData();
        var canvasData = cropper.getCanvasData();
        var tolerance = Math.max(containerData.width, containerData.height) * 0.002;
        if (cropBoxData.left < canvasData.left - tolerance ||
            cropBoxData.top < canvasData.top - tolerance ||
            cropBoxData.left + cropBoxData.width >
                canvasData.left + canvasData.width + tolerance ||
            cropBoxData.top + cropBoxData.height >
                canvasData.top + canvasData.height + tolerance) {
            cropper.setCropBoxData({
                left: Math.max(cropBoxData.left, canvasData.left),
                top: Math.max(cropBoxData.top, canvasData.top),
                width: Math.min(cropBoxData.width, canvasData.left + canvasData.width - cropBoxData.left, canvasData.width),
                height: Math.min(cropBoxData.height, canvasData.top + canvasData.height - cropBoxData.top, canvasData.height)
            });
        }
    };
    var handleCropperRotate = function (angle) {
        var _a;
        (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.rotate(angle);
        if (_cropper.current)
            _adjustCropboxToContainCanvas(_cropper.current);
        Gtag.event("e-cropper-tap_rotate".concat(angle === -90 ? 'Left' : 'Right'));
    };
    useEffect(function () {
        if (warnVisible)
            setTimeout(function () {
                setWarnVisible(false);
            }, 2000);
    }, [warnVisible]);
    var handleReset = function () {
        var _a;
        (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.reset();
        _ajustCropboxToFit(false);
        Gtag.event('e-cropper-tap_reset');
    };
    var handleConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _canvas, type, blob;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!_cropper.current) return [3, 3];
                    setDisabled(true);
                    _canvas = (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.getCroppedCanvas({
                        maxWidth: 1600,
                        maxHeight: 1600
                    });
                    return [4, urlToBlob(source.source).then(function (blob) {
                            if (blob.type.startsWith('image/') && blob.type.split('/')[1])
                                return blob.type.split('/')[1];
                            return 'png';
                        })];
                case 1:
                    type = _b.sent();
                    return [4, canvasToBlob(_canvas, type)];
                case 2:
                    blob = _b.sent();
                    setDisabled(false);
                    onConfirm(blob, _cropper.current.getData());
                    Gtag.event('e-cropper-tap_next');
                    _b.label = 3;
                case 3: return [2];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(Header, { title: I18n.format('modules.global.cropper'), renderCloseContent: renderHeaderCloseContent, onClose: onClose }), _jsxs("div", { className: "_sz-h-[calc(100%-120px)] md:_sz-h-[calc(100%-120px-48px)]", children: [_jsx("img", { ref: _image, src: source.source }), loading && (_jsx("div", { className: "_sz-absolute _sz-top-0 _sz-flex _sz-h-full _sz-w-full _sz-justify-center _sz-bg-white _sz-pt-[200px]", children: _jsx(Loading, { color: "var(--sunzi-theme-color)", className: "_sz-stroke-[3px]" }) }))] }), _jsx("div", { className: "_sz-hidden _sz-h-[60px] _sz-bg-white _sz-px-[50px] md:_sz-flex md:_sz-items-center", children: _jsx(Slider, { min: zoomLimit[0], max: zoomLimit[1], step: 0.01, value: zoom, onChange: function (value) {
                        var _a;
                        if (typeof value === 'number')
                            (_a = _cropper.current) === null || _a === void 0 ? void 0 : _a.zoomTo(value);
                    } }) }), _jsxs("div", { className: "_sz-flex _sz-h-[60px] _sz-items-center _sz-justify-end _sz-bg-white", children: [_jsx(Button, { className: "_sz-mx-2", onClick: handleReset, children: I18n.format('modules.global.reset') }), _jsxs("div", { className: "_sz-flex _sz-flex-1 _sz-items-center _sz-justify-center", children: [_jsx(Icon, { className: "_sz-mx-[5px] !_sz-h-10 !_sz-w-10 _sz-cursor-pointer", color: "#8c8c8c", onClick: function () { return handleCropperRotate(-90); }, children: _jsx(RotateLeft, {}) }), _jsx(Icon, { className: "_sz-mx-[5px] !_sz-h-10 !_sz-w-10 _sz-cursor-pointer", color: "#8c8c8c", onClick: function () { return handleCropperRotate(90); }, children: _jsx(RotateRight, {}) })] }), _jsx(Button, { className: "_sz-mx-2 _sz-font-medium", type: "theme", disabled: disabled, onClick: handleConfirm, children: I18n.format('next') })] }), warnVisible && (_jsx(Wrapper, { className: "_sz-pointer-events-none _sz-z-[11]", position: "absolute", children: _jsx(Drawer, { className: "_sz-flex _sz-justify-center _sz-py-2.5", position: "top", mask: false, children: _jsxs("div", { className: "_sz-flex _sz-h-10 _sz-items-center _sz-justify-center _sz-rounded-[20px] !_sz-border-[0.5px] !_sz-border-solid !_sz-border-black/[.12] _sz-bg-[#f5222d] _sz-pr-[15px] _sz-pl-2.5", children: [_jsx(Icon, { color: "#fff", children: _jsx(CircleWarnLine, {}) }), _jsx("span", { className: "_sz-pl-[5px] _sz-text-sm _sz-text-white", children: I18n.format('modules.cropper.min.size.warn') })] }) }) }))] }));
};
export default Croppie;
